import { render, staticRenderFns } from "./CategoriaProdutoTable.vue?vue&type=template&id=1dbb91eb"
import script from "./CategoriaProdutoTable.vue?vue&type=script&lang=js"
export * from "./CategoriaProdutoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports